import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82fde6d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert-block" }
const _hoisted_2 = { class: "switch-search" }
const _hoisted_3 = { class: "switch-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "switch-name" }
const _hoisted_6 = { class: "switch-date" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-circle-check" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_alert_box = _resolveComponent("alert-box")!

  return (_openBlock(), _createBlock(_component_alert_box, {
    dataTitle: "切换登录账户",
    width: "550px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.searchText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
            placeholder: "搜索公司名",
            onKeyup: _ctx.search
          }, null, 8, ["modelValue", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.switchList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "switch-item",
              key: index,
              onClick: ($event: any) => (_ctx.checkUser(item.client_user_id))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.client_name), 1),
                _createElementVNode("div", _hoisted_6, "开户时间：" + _toDisplayString(item.client_create_time), 1)
              ]),
              (item.client_name  === _ctx.clientName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                : _createCommentVNode("", true)
            ], 8, _hoisted_4))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}